<div class="">
    <div *ngIf="isCameraExist; else noCameraExist">
        <div style="text-align:center">
            <div class="row g-0">
                <button mat-raised-button class="col mx-1" (click)="takeSnapshot()">Prendre photo</button>
                <button *ngIf="CameraCount > 1" mat-raised-button class="col mx-1" (click)="changeWebCame(true)">Changer Camera</button>
                <!-- <button class="button" (click)="onOffWebCame()">Switch camera</button> -->
            </div> <br />
            <webcam [height]="WEBCAM_DISPLAY_HEIGHT" [width]="WEBCAM_DISPLAY_WIDTH" [trigger]="triggerObservable" (imageCapture)="handleImage($event)"
                *ngIf="showWebcam" [switchCamera]="nextWebcamObservable" [videoOptions]="videoOptions"></webcam>
        </div>
    
        <div *ngIf="errors.length > 0">
            <h4>Error Messages:</h4>
            <ul *ngFor="let error of errors">
                <li>{{ error | json }}</li>
            </ul>
        </div>
    </div>
    
    <ng-template #noCameraExist>
        Camera device not available
    </ng-template>

    <!-- <div class="d-flex m-auto" style="position:relative; display:inline-block;">
        <video [class.show]="!isCaptured" [class.hide]="isCaptured" #video id="video" [width]="WEBCAM_DISPLAY_WIDTH" [height]="WEBCAM_DISPLAY_HEIGHT" autoplay></video> -->
        <!-- <div [style.width]="WEBCAM_DISPLAY_WIDTH" [style.height]="WEBCAM_DISPLAY_HEIGHT"> -->
            <!-- <canvas [class.show]="isCaptured" [class.hide]="!isCaptured" #canvas id="canvas" [width]="WEBCAM_NEW_WIDTH" [height]="WEBCAM_NEW_HEIGHT"></canvas> -->
        <!-- </div> -->
        <!-- <div [class.panel-with-3icons]="hasMultipleCam()" [class.panel-with-2icons]="!hasMultipleCam()">
            <button *ngIf="isCaptured && !loadingTask.IsLoading" appPreventDoubleClick mat-mini-fab color="primary" (throttledClick)="deleteCapture();">
                <mat-icon>clear</mat-icon>
            </button>
            <button *ngIf="!isCaptured && !loadingTask.IsLoading" appPreventDoubleClick mat-mini-fab color="accent" (throttledClick)="capture()">
                <mat-icon aria-label="take-photo">photo_camera</mat-icon>
            </button>
            <button class="mx-3" *ngIf="hasMultipleCam() && !loadingTask.IsLoading" appPreventDoubleClick mat-mini-fab color="primary" (throttledClick)="switchCamera()">
                <mat-icon aria-label="cancel-photo">switch_camera</mat-icon>
            </button>
            <button [class.greyed]="!isCaptured" [class.validable]="isCaptured" appPreventDoubleClick *ngIf="!loadingTask.IsLoading" mat-mini-fab (throttledClick)="validatePhoto()" [disabled]="!isCaptured">
                <mat-icon aria-label="validate-photo">done</mat-icon>
            </button>
        </div> -->
    <!-- </div> -->
</div>